import { render, staticRenderFns } from "./KPICard.vue?vue&type=template&id=5f6f5b9d&scoped=true&"
import script from "./KPICard.vue?vue&type=script&lang=js&"
export * from "./KPICard.vue?vue&type=script&lang=js&"
import style0 from "./KPICard.vue?vue&type=style&index=0&id=5f6f5b9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6f5b9d",
  null
  
)

export default component.exports